module.exports = __webpack_public_path__ + "static/img/574_phase_function_Paper_Points.4fbf538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/574_phase_function_Paper_Points.png
// module id = SIth
// module chunks = 0